import {Component, OnChanges, OnDestroy, OnInit} from '@angular/core';
import {ActivatedRoute} from '@angular/router';
import {HeaderService} from '../../core/services/header.service';
import {Title} from '@angular/platform-browser';
import {BaseComponent} from '../../core/base.component';
import {AuthService} from '../../core/security/auth.service';
import {RolesEnum} from '../../core/security/roles.enum';
import {SoftPhoneService} from '../soft-phone.service';
import {SoftPhoneSummaryModel} from '../../api/models/soft-phone-summary-model';
import {DownloadLinkModel} from '../../api/models/download-link-model';
import { UntypedFormBuilder, UntypedFormGroup, Validators, FormsModule, ReactiveFormsModule } from '@angular/forms';
import {passwordValidator} from '../../core/validators/password.validator';
import {matchFields} from '../../core/validators/match-fields.validator';
import {SoftPhoneChangePasswordModel} from '../../api/models/soft-phone-change-password-model';
import {NotificationService} from '../../notification/notification.service';
import { MatCard, MatCardTitle, MatCardContent } from '@angular/material/card';
import { NgIf, NgFor } from '@angular/common';
import { CardComponent } from '../../core/visual/card/card.component';
import { MatPasswordInputComponent } from '../../editors/mat-password-input/mat-password-input.component';
import { MatButton } from '@angular/material/button';
import { MatTooltip } from '@angular/material/tooltip';
import { Angular2PromiseButtonModule } from 'angular2-promise-buttons';
import { UnixTimePipe } from '../../core/pipes/unix-time.pipe';
import { YesNoPipe } from '../../core/pipes/yesno.pipe';

@Component({
    selector: 'app-softphone-summary',
    templateUrl: './summary.component.html',
    styleUrls: ['./summary.component.scss'],
    standalone: true,
    imports: [
        MatCard,
        MatCardTitle,
        MatCardContent,
        NgIf,
        CardComponent,
        FormsModule,
        ReactiveFormsModule,
        MatPasswordInputComponent,
        MatButton,
        MatTooltip,
        Angular2PromiseButtonModule,
        NgFor,
        UnixTimePipe,
        YesNoPipe,
    ],
})
export class SummaryComponent extends BaseComponent implements OnInit, OnDestroy, OnChanges {

  detailsUrl: string;
  buttonSubmitPromise: Promise<boolean>;
  isLoading = false;
  hasError = false;
  submitted = false;
  changePasswordForm: UntypedFormGroup;
  summaryModel: SoftPhoneSummaryModel = {};
  links: DownloadLinkModel[] = [];

  constructor(route: ActivatedRoute, headerService: HeaderService, titleService: Title,
              public authService: AuthService,
              public softPhoneService: SoftPhoneService,
              private notificationService: NotificationService,
              private fb: UntypedFormBuilder
  ) {
    super(route, headerService, titleService, authService);

    this.editRoles = [RolesEnum.SoftPhoneEdit, RolesEnum.SoftPhoneDelete];
    this.deleteRoles = [RolesEnum.SoftPhoneDelete];

    this.createForm();
  }

  async ngOnInit() {
    this.getSummary().then(() => {
      console.log('After getSummary');
    });

    this.getLinks().then(() => {
      console.log('After getLinks');
    });

    console.log('on init');
    await super.ngOnInit();
  }

  async getSummary(): Promise<void> {
    this.summaryModel = await this.softPhoneService.getSoftphoneSummary();
  }

  async getLinks(): Promise<void> {
    this.links = await this.softPhoneService.getSoftphoneLinks();
  }

  ngOnDestroy() {
    super.ngOnDestroy();
  }

  createForm(): void {

    this.changePasswordForm = this.fb.group({
        'newPassword': ['', [Validators.required, passwordValidator]],
        'confirmPassword': ['', Validators.required]
      },
      {validator: matchFields('newPassword', 'confirmPassword')}
    );
  }

  ngOnChanges() {
    this.submitted = false;
    this.changePasswordForm.reset({});
  }

  async onSubmit() {
    this.submitted = true;
    this.hasError = false;

    if (this.changePasswordForm.valid) {
      this.buttonSubmitPromise = this.processSubmit();
    }
  }

  async processSubmit(): Promise<boolean> {

    const reqData = this.prepareFormModel();

    if (await this.softPhoneService.changeSoftPhonePassword(reqData)) {
      this.notificationService.notifySuccess('SoftPhone password successfully changed');
      this.ngOnChanges();
    } else {
      this.hasError = true;
    }

    return true;
  }

  prepareFormModel(): SoftPhoneChangePasswordModel {
    const formModel = this.changePasswordForm.value;

    return {
      password: formModel.newPassword as string,
      ccsUserId: this.summaryModel.ccsUserId!,
    };
  }
}
